/**
 * ClinicalHUD3 — collection-name and Live-attestation constants.
 * Do not import into other modules until later build prompts wire them up.
 *
 * Keep CLINICAL_HUD3_ATTESTATION_STATEMENT_VERSION and
 * CLINICAL_HUD3_ATTESTATION_STATEMENT_TEXT in sync with
 * functions/src/clinicalHud3/constants.js.
 */

export const CLINICAL_HUD3_TEACHING_COLLECTION = "clinicalHud3Teaching";
export const CLINICAL_HUD3_LIVE_COLLECTION = "clinicalHud3Live";
export const CLINICAL_HUD3_LIVE_ACCESS_COLLECTION = "clinicalHud3LiveAccess";
export const CLINICAL_HUD3_LIVE_ATTESTATION_COLLECTION =
  "clinicalHud3LiveAttestation";
export const CLINICAL_HUD3_USAGE_LOG_COLLECTION = "clinicalHud3UsageLog";
export const CLINICAL_HUD3_LEARNER_PROFILE_COLLECTION =
  "clinicalHud3LearnerProfile";
export const CLINICAL_HUD3_CASES_COLLECTION = "clinicalHud3Cases";
export const CLINICAL_HUD3_CASE_KEYS_COLLECTION = "clinicalHud3CaseKeys";

// OWNER: confirm exact filed mark before launch
export const CLINICAL_HUD3_PUBLIC_MARK = "ClinicalHUD";

export const CLINICAL_HUD3_USAGE_EVENTS = Object.freeze([
  "teaching_session_started",
  "teaching_ddx_committed",
  "teaching_case_completed",
  "live_session_started",
]);

export const CLINICAL_HUD3_ATTESTATION_STATEMENT_VERSION = "v1";

export const CLINICAL_HUD3_ATTESTATION_STATEMENT_TEXT =
  "[ATTORNEY TO SUPPLY — PLACEHOLDER] My organization authorizes me to use patient information in this tool, and I accept responsibility for doing so in compliance with my organization's policies and applicable law.";
